import React, { createContext, useState } from 'react';

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {

  const [state, setState] = useState({
    colorData: [
      {
        id: 1,
        value: "rgb(224, 114, 110)",

      },
      {
        id: 2,
        value: "rgb(199, 196, 196)",
      },
      {
        id: 3,
        value: "rgb(224, 145, 119)",
      },
      {
        id: 4,
        value: "rgb(234, 190, 120)",
      },
      {
        id: 5,
        value: "rgb(245, 223, 130)",
      },
      {
        id: 6,
        value: "rgb(188, 221, 158)",
      },
      {
        id: 7,
        value: "rgb(147, 199, 171)",
      },
      {
        id: 8,
        value: "rgb(174, 229, 227)",
      },
      {
        id: 10,
        value: "rgb(174, 229, 227)",
      },
      {
        id: 11,
        value: "rgb(157, 154, 231)",
      },
      {
        id: 12,
        value: "rgb(197, 153, 229)",
      },
      {
        id: 13,
        value: "rgb(238, 175, 235)",
      },
      {
        id: 14,
        value: "rgb(226, 120, 176)",
      },
      {
        id: 15,
        value: "rgb(239, 156, 156)",
      },
      {
        id: 16,
        value: "rgb(130, 130, 130)",
      },
    ],
  });

  return (
    <GlobalContext.Provider value={{ state, setState }}>
      {children}
    </GlobalContext.Provider>
  );
};
